import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "../i18n";
import Footer from "../components/Footer";
import HeroAbout from "../components/HeroAbout";
import Experience from "../components/Experience";
import Education from "../components/Education";
import History from "../components/History";
import NavBar from "../components/Navbar/NavBar";
import { useDocTitle } from "../components/CustomHook";
import { Helmet } from 'react-helmet';

const About = () => {
  useDocTitle("kesnelDigital - About");

  return (
    <I18nextProvider i18n={i18n}>
      <div>
        <Helmet>
          <meta name="description" content="Kesnel Digital is an independent software studio in Belfort, France. Work directly with the developer behind your project: clear communication, modern technology, and custom software built with care." />
        </Helmet>
        <NavBar />
      </div>
      <div>
        <HeroAbout />
        <Experience />
        <Education />
        <History />
      </div>
      <Footer />
    </I18nextProvider>
  );
};

export default About;
